import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { InactiveGenieAdminService } from "@/services/admin/InactiveGenieAdminService";
import type { InactiveGenieFilters } from "@/types/admin/inactive-genies";

export const INACTIVE_GENIES_PAGE_SIZE = 50;

export const INACTIVE_GENIES_QUERY_KEY = "admin-inactive-genies";

export const useInactiveGenies = (filters: InactiveGenieFilters, page: number) =>
  useQuery({
    queryKey: [INACTIVE_GENIES_QUERY_KEY, filters, page],
    queryFn: () =>
      InactiveGenieAdminService.list(filters, INACTIVE_GENIES_PAGE_SIZE, (page - 1) * INACTIVE_GENIES_PAGE_SIZE),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
